import { createContext, useContext, useEffect, useState, useCallback } from "react";
import { setLanguage } from "../i18n";
import { api } from "../lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
      if (data.language && !localStorage.getItem("nini_lang")) setLanguage(data.language);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    if (!localStorage.getItem("nini_token")) { setUser(false); return; }
    refresh();
  }, [refresh]);

  const login = (data) => {
    localStorage.setItem("nini_token", data.token);
    setUser(data.user);
    if (data.user?.language && !localStorage.getItem("nini_lang")) setLanguage(data.user.language);
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("nini_token");
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, setUser, login, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
